import { OperatorTerminalHeader as KioskHeader } from "../terminal/OperatorTerminalHeader";
import { TechnicalManagerWorkspace } from "../TechnicalManagerWorkspace";
import { useActiveShift } from "../useActiveShift";
import { shiftHours } from "../production-time";
import type { ProductionWorkspaceProps } from "../production-workspace-contract";

export function TechnicalManagerProductionBoard(props: ProductionWorkspaceProps) {
  const shiftCode = useActiveShift();
  return <div className="production-supervisor-shell technical-manager-shell"><KioskHeader label="Teknik Departman · Operasyon Merkezi" hours={shiftHours(shiftCode)} user={props.user} onLogout={props.onLogout} /><TechnicalManagerWorkspace refreshVersion={props.dataRefreshVersion} notify={props.notify} /></div>;
}
